import { Component, Input, OnInit } from '@angular/core';
import { Article } from 'src/app/api';
import { AppComponent } from 'src/app/app.component';
import { NgIf, NgOptimizedImage, DatePipe } from '@angular/common';

@Component({
    selector: 'app-news-card',
    templateUrl: './news-card.component.html',
    styleUrls: ['./news-card.component.scss'],
    standalone: true,
    imports: [NgIf, NgOptimizedImage, DatePipe]
})
export class NewsCardComponent implements OnInit {
  @Input() bgType = '';
  @Input() isLateralCard = false;
  @Input() showDescription = false;
  @Input() isNewsAgentCard = false;
  @Input() article: Article;

  constructor(public main: AppComponent) { }

  ngOnInit(): void {
  }

  generateUrl(): string {
    if (this.article?.type !== 'editorial' && this.article?.writtenBy?.agent?.slug) {
      return `/news/${this.article?.slug}/${this.article?.writtenBy?.agent?.slug}`;
    } else if (this.article?.type !== 'editorial' && this.article?.writtenBy?.professionist?.slug) {
      return `/news/${this.article?.slug}/${this.article?.writtenBy?.professionist?.slug}`;
    } else{
      return `/news/${this.article?.slug}`;
    }
  }

  imageArticle(): string {
    try {
      return this.article?.hero_img
        ? this.article?.hero_img
        : '';
    } catch (error) {
      return '../../../../assets/img/placeholders/annuncio.jpg';
    }
  }



}
